<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        Pokaż kolumny:
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around">
          <v-col cols="1" v-for="header in localHeaders" :key="header.id">
            <v-checkbox
              :input-value="isChecked(header)"
              :label="header.text"
              @change="changeVisibility(header)"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="js">

export default {
  props: { headers: { type: Array, default: () => [] } },
  computed: {
    localHeaders() {
      return this.headers
    }
  },
  methods: {
    changeVisibility(header) {
      if (this.isChecked(header)) {
        header.align = ' d-none'
      } else {
        header.align = 'center'
      }
      this.$emit('input', this.localHeaders)
    },
    isChecked(header) {
      return header.align !== ' d-none'
    }
  }
}
</script>

<style scoped></style>
